var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx } from "react/jsx-runtime";
/* eslint-disable react/require-default-props */
import { useGetPlannedTaskTags } from '@/shared/hooks/task/useGetPlannedTaskTags';
import { dynamicSort } from '@/shared/utils/dynamicSort';
import MultiSelect, { splitItems } from '../multiselect/MultiSelect';
export var PlannedTasksTagsMultiSelect = function (_a) {
    var selectedItems = _a.selectedItems, placeholder = _a.placeholder, onChange = _a.onChange, onFilterBehaviourChanged = _a.onFilterBehaviourChanged, filterBehaviour = _a.filterBehaviour, withFilterBehaviour = _a.withFilterBehaviour;
    var data = useGetPlannedTaskTags().data;
    var taskLabels = data === null || data === void 0 ? void 0 : data.map(function (x) { return ({ id: x.id, label: x.name, sort: x.name.toLowerCase() }); }).sort(dynamicSort('sort'));
    var _b = splitItems(taskLabels, selectedItems, 'id'), selectedLabels = _b[0], availableLabels = _b[1];
    return (_jsx(MultiSelect, { selectedItem: selectedLabels, onItemRemoved: function (item) { return onChange(selectedItems === null || selectedItems === void 0 ? void 0 : selectedItems.filter(function (label) { return label !== item.value.id; })); }, onItemSelected: function (item) { return onChange(__spreadArray(__spreadArray([], (selectedItems !== null && selectedItems !== void 0 ? selectedItems : []), true), [item.id], false)); }, items: availableLabels, placeholder: placeholder, onFilterBehaviourChanged: function (behaviour) {
            return onFilterBehaviourChanged(behaviour);
        }, filterBehaviour: filterBehaviour, withFilterBehaviour: withFilterBehaviour }));
};
export var FilterPlannedTasksTagsMultiSelect = function (_a) {
    var _b;
    var item = _a.item, setFilter = _a.setFilter, activeFilters = _a.activeFilters, label = _a.label, isAlwaysVisible = _a.isAlwaysVisible, withFilterBehaviour = _a.withFilterBehaviour, enabled = _a.enabled;
    return ({
        filterItem: item,
        enabled: enabled,
        filterSelectLabel: !isAlwaysVisible ? label : undefined,
        element: (_jsx(PlannedTasksTagsMultiSelect, { onChange: function (value) {
                var _a;
                var _b;
                setFilter((_a = {},
                    _a[item] = ((_b = value === null || value === void 0 ? void 0 : value.length) !== null && _b !== void 0 ? _b : 0) > 0 ? value : undefined,
                    _a));
            }, selectedItems: activeFilters[item], placeholder: label, withFilterBehaviour: withFilterBehaviour, onFilterBehaviourChanged: function (filterBehaviour) {
                var _a;
                setFilter({
                    filterBehaviours: (_a = {},
                        _a[item] = filterBehaviour,
                        _a),
                });
            }, filterBehaviour: (_b = activeFilters.filterBehaviours) === null || _b === void 0 ? void 0 : _b[item] })),
    });
};
